<template>
  <div class="inicio">
    <Header />
    <Welcome />
    <VideoRegister />
    <ForDoctorsPatients />
    <Status />
    <Solution />
    <Download />
    <HowItWorks />
    <WhatGet />
    <Origin />
    <Contact />
    <Footer />
  </div>
</template>

<script>
import Header from './header.vue'
import Welcome from './welcome.vue'
import VideoRegister from './video-register.vue'
import ForDoctorsPatients from './for-doctors-patients.vue'
import Status from './status.vue'
import Solution from './solution.vue'
import Download from './download.vue'
import HowItWorks from './how-it-works.vue'
import WhatGet from './what-get.vue'
import Origin from './origin.vue'
import Contact from './contact.vue'
import Footer from './footer.vue'

export default {
  name: 'Inicio',
  components: {
    Header,
    Welcome,
    VideoRegister,
    ForDoctorsPatients,
    Status,
    Solution,
    Download,
    HowItWorks,
    WhatGet,
    Origin,
    Contact,
    Footer
  },
  mounted () {
    this.$nextTick(() => {
      document.querySelector('.inicio').scrollIntoView()
    })
  }
}
</script>

<style lang="scss" scoped>
.inicio {}
</style>



// WEBPACK FOOTER //
// src/components/inicio.vue